import { render, staticRenderFns } from "./StockTransferPrint.vue?vue&type=template&id=155d513b&"
import script from "./StockTransferPrint.vue?vue&type=script&lang=js&"
export * from "./StockTransferPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports